<template>
  <div>
    <div v-for="item in availableAddresses" :key="item.key">
      <div class="row mt-5 b-form__row_type_flex">
        <div class="col-6">
          <div class="b-form__container">
            <label>{{$t('CONTENT.counterparty.address_type')}}</label>
            <AddressSelect :addressTypeFullName="item"></AddressSelect>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-8">
          <div class="b-form__container">
            <label :for="`address-${item.idInDB}`">{{$t('CONTENT.counterparty.address')}}</label>
            <textarea class="b-textarea" :id="`address-${item.idInDB}`" :name="`address-${item.idInDB}`" v-model="item.address">{{item.address}}</textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5" v-if="getAvalableAdressTypes.length !== 0">
      <div class="col-5">
        <div class="b-form__container">
          <button class="b-btn" type="button" @click="addNewAddress()">
            <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
            {{$t('CONTENT.counterparty.add_address')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Address from '../../../../models/counterparty/Address';
	import AddressSelect from './AddressSelect';
	import {mapGetters} from 'vuex';

	export default {
		components: {
			AddressSelect
		},
		props: {
			addresses: {
				required: true,
        type: Array,
			}
		},
		data() {
			return {
				selectedAddressTypes: [],
        currentAddressType: '',
				availableAddresses: [],
			}
		},
		computed: {
			...mapGetters(['allCounterpartyAddressTypes']),
			...mapGetters(['getAddedAdresses']),
			...mapGetters(['getAvalableAdressTypes']),
		},
		created() {
			this.$store.commit('CLEAR_SELECTED_ADDRESS_TYPES');
			this.$store.commit('CLEAR_ADDED_ADDRESSES');

			if (this.addresses.length === 0) {
				this.addNewAddress();
			} else {
				this.$store.commit('UPDATE_ADDED_ADDRESSES_FOR_EDIT', this.addresses);
				this.$store.commit('UPDATE_SELECTED_ADDRESS_TYPES_FOR_EDIT', this.addresses);
      }

			this.availableAddresses = this.getAddedAdresses;
		},
		methods: {
			addNewAddress() {
				let address = Address.createNew(this.getAvalableAdressTypes[0].addressFullName);
				address.key = Date.now();
				this.$store.commit('ADD_ADDRESS', address);
			},
    }
	}
</script>
